
import Page2 from '../../Pages/Page2/Page2';
import Page3 from '../../Pages/Page3/Page3';
import Page4 from '../../Pages/Page4/Page4';
import Page5 from '../../Pages/Page5/Page5';
import Page1 from './../../Pages/Page1/Page1';

export default function Main(){
    return <>
    <Page1/>
    <Page2/>
    <Page3/>
    <Page4/>
    <Page5/>
    </>
}